(function () {
	const initSlider = () => {
		const productSliders = document.querySelectorAll('.banner-products__swiper');
		const productCardCount = productSliders[0]?.getAttribute('data-product-card-count');
	
		productSliders.forEach((slider) => {
			const section = slider.closest('.section__banner-products');
	
			const nextEl = section.querySelector('.banner-products__button-next');
			const prevEl = section.querySelector('.banner-products__button-prev');
	
			new Swiper(slider, {
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 8,
				breakpoints: {
					768: {
						slidesPerView: 4,
						autoplay: false,
					},
					1024: {
						slidesPerView: productCardCount,
					}
				},
			});
		});
	};	

	const destroySlider = () => {
		const productSliders = document.querySelectorAll('.banner-products__swiper');

		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.section__banner-products');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
		});

		destroySlider();
		initSlider();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	initSection();

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();


